import { JWTValidationError } from '../types';

export interface State {
  expectedEmail?: string;
  foundEmail?: string;
  recoveryUrl?: URL;
  error?: JWTValidationError | 'unknown_error';
}

export const defaultState: State = {};

const socialLoginRecovery = (state: State = defaultState): State => state;

export default socialLoginRecovery;
